import React from "react";
import AsyncSelect from "react-select/lib/Async";
import CardEmpty from "Utils/Cards/CardEmpty";
import Select from "react-select";
import { nivel_contaminacion } from "../../../../../../../utility/constants";

export const Contaminantes = ({
    contaminantes = [],
    Agregar,
    Eliminar,
    Actualizar,
    loadContaminantes,
    isModoAnalisis,
}) => {
    let tableContent = null;

    if (isModoAnalisis) {
        tableContent = (
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ACCIONES</th>
                        <th className="text-center">CONTAMINANTE</th>
                        <th className="text-center">NIVEL</th>
                    </tr>
                </thead>

                <tbody>
                    {contaminantes.length === 0 && (
                        <tr>
                            <td colSpan={3} className="text-center">
                                No hay contaminantes
                            </td>
                        </tr>
                    )}

                    {contaminantes.map((item, index) => (
                        <tr key={index}>
                            {/* DELETE */}
                            <td className="text-center">
                                <img
                                    src={require("assets/img/icons/borrar.png")}
                                    className="action_img"
                                    onClick={() => Eliminar(index)}
                                />
                            </td>

                            {/* CONTAMINANTE */}
                            <td>
                                <AsyncSelect
                                    className="react-select-container"
                                    value={item.material_contaminante}
                                    isSearchable
                                    isClearable
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={loadContaminantes}
                                    getOptionValue={(option) => option.nombre}
                                    getOptionLabel={(option) => option.nombre}
                                    onChange={(val) =>
                                        Actualizar(
                                            index,
                                            "material_contaminante",
                                            val,
                                        )
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </td>

                            {/* NIVEL */}
                            <td>
                                <Select
                                    isClearable={true}
                                    className="react-select-container"
                                    backspaceRemovesValue={false}
                                    isSearchable
                                    options={nivel_contaminacion}
                                    placeholder={"Seleccione..."}
                                    onChange={(e) => {
                                        Actualizar(
                                            index,
                                            "nivel_contaminacion",
                                            e ? e.value : null,
                                        );
                                    }}
                                    value={
                                        nivel_contaminacion.find(
                                            (opt) =>
                                                opt.value ===
                                                item.nivel_contaminacion,
                                        ) || null
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    } else {
        tableContent = (
            <table className="table-striped">
                <thead>
                    <tr>
                        <th className="text-center">CONTAMINANTE</th>
                        <th className="text-center">NIVEL</th>
                    </tr>
                </thead>

                <tbody>
                    {contaminantes.length === 0 && (
                        <tr>
                            <td colSpan={2} className="text-center">
                                No hay contaminantes
                            </td>
                        </tr>
                    )}

                    {contaminantes.map((item, index) => {
                        const materialContaminante = item.material_contaminante
                            ? item.material_contaminante.nombre
                            : "";

                        const nivelContaminacion = nivel_contaminacion.find(
                            (opt) => opt.value === item.nivel_contaminacion,
                        );

                        const nivelContaminacionLabel = nivelContaminacion
                            ? nivelContaminacion.label
                            : "";

                        return (
                            <tr key={index}>
                                {/* CONTAMINANTE */}
                                <td className="text-center">
                                    {materialContaminante}
                                </td>

                                {/* NIVEL */}
                                <td className="text-center">
                                    {nivelContaminacionLabel}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <div className="mt-4">
            <CardEmpty noShadow>
                <h6 className="mb-3">CONTROL DE SUCIEDAD</h6>
                <div className="new-table-wrapper">{tableContent}</div>

                <div className="d-flex justify-content-center my-3">
                    {isModoAnalisis && (
                        <button
                            type="button"
                            className="btn btn-outline-info"
                            onClick={Agregar}
                        >
                            AGREGAR CONTAMINANTE
                        </button>
                    )}
                </div>
            </CardEmpty>
        </div>
    );
};
